import axios from 'axios'
import moment from 'moment'

const STATIONS_URL = 'https://data.raspberryshake.org/fdsnws/station/1/query'
const EVENTS_URL = 'https://quakelink.raspberryshake.org/events/query'
const SOUND_URL = '/api/get_wave'

function round (number, precision) {
  var factor = Math.pow(10, precision)
  return Math.round(number * factor) / factor
}

export const clamp = (number, min, max) => {
  return Math.min(Math.max(number, min), max)
}

export const getStations = (stationName) => {
  return axios.get(STATIONS_URL, {
    params: {
      format: 'text',
      level: 'station',
      station: stationName.toUpperCase() + '*'
    }
  }).then(function (response) {
    var lines = response.data.split('\n')
    var stations = lines.slice(1).map(function (line) {
      var fields = line.split('|')
      var station = {
        network: fields[0],
        station: fields[1],
        // location: fields[2],
        // channel: fields[3],
        latitude: fields[2],
        longitude: fields[3],
        elevation: fields[4]
      }
      // if (fields.length > 16 && fields[16]) {
      //   station.offline = true
      // }
      return station
    })
    return stations
  }).catch((error) => {
    console.log(error)
    return []
  })
}

export const getChannels = (station) => {
  return axios.get(STATIONS_URL, {
    params: {
      format: 'text',
      level: 'channel',
      station: station.toUpperCase()
    }
  }).then(function (response) {
    var lines = response.data.split('\n')
    var channels = lines.slice(1)
      .map(function (line) {
        var fields = line.split('|')
        var channel = fields[3]
        return channel
      })
      .filter(c => c)
    return [...new Set(channels)]
  }).catch((error) => {
    console.log(error)
    return []
  })
}

export const getEvents = (parameters) => {
  //parameters['format'] = 'text'

  return axios.get(EVENTS_URL, {
    params: parameters
  }).then(function (response) {
    var lines = response.data.split('\n').filter((v) => v)
    var events = lines.map(function (line) {
      var fields = line.split(';')
      var event = {
        id: fields[0],
        time: moment(fields[2]),
        mag: round(fields[3], 1),
        mag_type: fields[4],
        latitude: parseFloat(fields[5]),
        longitude: parseFloat(fields[6]),
        depth: fields[7],
        location: fields[12]
      }
      return event
    })
    return events
  })
}

export const getSound = (parameters) => {
  return axios.post(
    SOUND_URL,
    parameters
  ).then(response => {
    return response.data
  })
}
